import type { QueryClient } from '@tanstack/react-query';

/* ==========================================================================
   Chaves de cache do Atendente IA, por estabelecimento (design D24)

   Toda chave começa por `['customer-agent', tenantId]`: a troca de loja não
   limpa o cache, e uma chave sem o tenant mostraria a prontidão e as
   lacunas da outra loja. O estado (`status`) é a chave que a tela
   Atendimento (`customer-agent-handoff`) já usava; `customerAgentStatusKeys`
   de `conversations-keys.ts` passa a ler daqui, sem fábrica paralela.

   Fica fora dos hooks para a conexão de pedidos (`useOrdersSignalR`) e o
   Vapt IA invalidarem sem carregar a página.
   ========================================================================== */

export const customerAgentKeys = {
  root: (tenantId: string) => ['customer-agent', tenantId] as const,
  status: (tenantId: string) => [...customerAgentKeys.root(tenantId), 'status'] as const,
  settings: (tenantId: string) => [...customerAgentKeys.root(tenantId), 'settings'] as const,
  notes: (tenantId: string) => [...customerAgentKeys.root(tenantId), 'notes'] as const,
  entryLink: (tenantId: string) => [...customerAgentKeys.root(tenantId), 'entry-link'] as const,
  readiness: (tenantId: string) => [...customerAgentKeys.root(tenantId), 'readiness'] as const,
  knowledgeGaps: (tenantId: string) => [...customerAgentKeys.root(tenantId), 'knowledge-gaps'] as const,
};

/**
 * `customer_agent.status_changed` é campainha: além do estado, a página relê
 * a configuração (o `enabled` e o `pausedUntil` que outra aba gravou). Com o
 * formulário alterado, a releitura não muda a versão-base dele (D4).
 */
export function invalidateCustomerAgentSettings(queryClient: QueryClient, tenantId: string): void {
  if (!tenantId) return;
  void queryClient.invalidateQueries({ queryKey: customerAgentKeys.settings(tenantId) });
}

/**
 * `whatsapp.connection_updated` muda o link de entrada: conectado, a seção
 * mostra o link e o QR; fora de `connected`, o aviso. Sem esta releitura o
 * link ficaria preso ao estado em que a página abriu (o painel não relê no
 * foco).
 */
export function invalidateCustomerAgentEntryLink(queryClient: QueryClient, tenantId: string): void {
  if (!tenantId) return;
  void queryClient.invalidateQueries({ queryKey: customerAgentKeys.entryLink(tenantId) });
}
